/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const systemStateStrings = {
  title: 'System State',
  tab: 'Latest Activities',

  columns: {
    index: 'ID',
    username: 'Username',
    activity: 'Activity name',
    activityDate: 'Activity Date',
  },

  subtitle: 'Everything users have done in the system, newest first',
  searchPlaceholder: 'Search by username or activity',
  empty: 'No matching activity',
  actionFailed: 'The log could not be loaded',

  summary: {
    caption: 'Log at a glance',
    total: 'Total activity',
    latest: 'Last activity',
  },

  exportNote: 'Export is not available from this screen yet — the operation has not been moved to the API.',

  exportExcel: 'Export to Excel',
  exportPdf: 'Export to PDF',
}

export const notificationsLogStrings = {
  title: 'System Notifications Details',

  columns: {
    type: 'Type',
    status: 'Status',
    createdOn: 'Created On',
    startDate: 'Start Date',
    endDate: 'End Date',
  },

  messageColumns: {
    status: 'Status',
    lastStatusDate: 'Last Status Date',
    details: 'Details',
  },

  filter: 'Search',
  reset: 'Cancel',
  type: 'Type',
  status: 'Status',
  details: 'Details',
  preview: 'Preview',
  delete: 'Delete',
  close: 'Close',
  deleteConfirm: 'Are you sure you want to delete this Notification Event?',
  deleted: 'Operation Completed Successfully',
  deleteFailed: 'Operation Failed',
  yes: 'Yes',
  no: 'No',

  states: {
    Waiting: 'Waiting',
    Running: 'Running',
    Stopped: 'Stopped',
    Finished: 'Completed',
    Failed: 'Failed',
    Succeeded: 'Succeeded',
  },

  deletableState: 'Waiting',
}
